"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var customer_exports = {};
__export(customer_exports, {
  Customer: () => Customer
});
module.exports = __toCommonJS(customer_exports);
var Customer;
((Customer2) => {
  let Data;
  ((Data2) => {
    Data2.path = "customer/data";
  })(Data = Customer2.Data || (Customer2.Data = {}));
  let Exists;
  ((Exists2) => {
    Exists2.path = "customer/exists";
  })(Exists = Customer2.Exists || (Customer2.Exists = {}));
  let Login;
  ((Login2) => {
    Login2.path = "customer/login";
  })(Login = Customer2.Login || (Customer2.Login = {}));
  let Logout;
  ((Logout2) => {
    Logout2.path = "customer/logout";
  })(Logout = Customer2.Logout || (Customer2.Logout = {}));
  let Register;
  ((Register2) => {
    Register2.path = "customer/register";
  })(Register = Customer2.Register || (Customer2.Register = {}));
  let Save;
  ((Save2) => {
    Save2.path = "customer/save";
  })(Save = Customer2.Save || (Customer2.Save = {}));
  let SaveAddress;
  ((SaveAddress2) => {
    SaveAddress2.path = "customer/saveAddress";
  })(SaveAddress = Customer2.SaveAddress || (Customer2.SaveAddress = {}));
  let RemoveAddress;
  ((RemoveAddress2) => {
    RemoveAddress2.path = "customer/removeAddress";
  })(RemoveAddress = Customer2.RemoveAddress || (Customer2.RemoveAddress = {}));
  let Orders;
  ((Orders2) => {
    Orders2.path = "customer/orders";
  })(Orders = Customer2.Orders || (Customer2.Orders = {}));
  let RemoveSavedCard;
  ((RemoveSavedCard2) => {
    RemoveSavedCard2.path = "customer/removeSavedCard";
  })(RemoveSavedCard = Customer2.RemoveSavedCard || (Customer2.RemoveSavedCard = {}));
  let RequestPasswordReset;
  ((RequestPasswordReset2) => {
    RequestPasswordReset2.path = "customer/password";
  })(RequestPasswordReset = Customer2.RequestPasswordReset || (Customer2.RequestPasswordReset = {}));
  let ApplyPasswordReset;
  ((ApplyPasswordReset2) => {
    ApplyPasswordReset2.path = "customer/resetPassword";
  })(ApplyPasswordReset = Customer2.ApplyPasswordReset || (Customer2.ApplyPasswordReset = {}));
})(Customer || (Customer = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Customer
});
